import { breakpoints } from '../utils/breakpoints';

const selectors = {
  btn: '.js-swap-btn',
  img: '.js-swap-img',
  section: '.js-swap-section',
  lazy: '.js-swap-lazy',
};

const state = {
  active: 'is-active',
};

const handleSwapImg = () => {
  // Disable on mobile
  if (window.innerWidth < breakpoints.tablet) return;

  const section = document.querySelector(selectors.section);
  if (!section) return;
  const lazyElems = section.querySelectorAll(selectors.lazy);

  const imgs = [...section.querySelectorAll(selectors.img)];

  // Disable when imgs not found
  if (!imgs.length) return;

  const btns = [...section.querySelectorAll(selectors.btn)];

  const imageObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          lazyElems.forEach((image) => {
            image.srcset = image.dataset.srcset;

            imageObserver.unobserve(image);
          });
        }
      });
    },
    { rootMargin: '1000px' }
  );

  imageObserver.observe(section);

  const removeActive = () => {
    imgs.forEach((img) => img.classList.remove(state.active));
  };

  btns.forEach((item) => {
    item.addEventListener('mouseenter', () => {
      removeActive();

      // finding matching elem
      const activeImg = imgs.find((img) => img.dataset.id == item.dataset.id);

      // add class to found elem
      activeImg.classList.add(state.active);
    });
  });
};

export default handleSwapImg;
